<template>
  <div class="settings-layout">
    <page-header :title="$tc('navbar.configuration', 2)" />
    <div class="block block-rounded">
      <ul class="nav nav-tabs nav-tabs-block pl-4" role="tablist">
        <li class="nav-item" role="presentation">
          <router-link
            class="nav-link"
            active-class="active"
            exact-active-class="active"
            :to="{ name: 'settings.index', params: { clientId: currentClient.uuid } }"
            exact
            role="tab">
            {{ $t('organization.name') }}
          </router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link
            class="nav-link"
            active-class="active"
            exact-active-class="active"
            :to="{ name: 'branding.index', params: { clientId: currentClient.uuid } }"
            exact
            role="tab">
            {{ $t('branding.name') }}
          </router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link
            class="nav-link"
            active-class="active"
            exact-active-class="active"
            :to="{ name: 'about-us.index', params: { clientId: currentClient.uuid } }"
            role="tab">
            {{ $t('about_us') }}
          </router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link
            class="nav-link"
            active-class="active"
            exact-active-class="active"
            :to="{ name: 'documents.index', params: { clientId: currentClient.uuid } }"
            role="tab">
            {{ $tc('document.name', 2) }}
          </router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link
            class="nav-link"
            active-class="active"
            exact-active-class="active"
            :to="{ name: 'websiteMetadata.index', params: { clientId: currentClient.uuid } }"
            exact
            role="tab">
            {{ $t('websiteMetadata') }}
          </router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link
            class="nav-link"
            active-class="active"
            exact-active-class="active"
            :to="{ name: 'export-stats-mapping.index', params: { clientId: currentClient.uuid } }"
            role="tab">
            {{ $tc('exportStatsMapping.name', 1) }}
          </router-link>
        </li>
      </ul>
      <div class="block-content tab-content">
        <div class="tab-pane active show" role="tabpanel" tabindex="0">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentClient () {
      return this.$store.state.currentClient
    }
  }
}
</script>

<style scoped>
.nav-link.active {
  color: #5c80d1 !important;
}
</style>
